































































































































import { defineComponent } from "@vue/composition-api";
import NumberFormatter from "@/services/number.formatter";
import { Interval, createNewDefaultInterval } from "@/models/Interval";
import { BlockLabel } from "@/models/BlockLabel";
import FeeBase from "@/models/FeeBase";
import {
  Expandable,
  TextField,
  BlockContainer,
  Checkbox,
} from "@/components";

export default defineComponent({
  name: "FixedAmount",
  components: {
    Expandable,
    TextField,
    BlockContainer,
    Checkbox,
  },
  props: {
    initialLimit: { type: Number, default: 0 },
    blockId: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    data: { type: Object, default: null },
  },
  data() {
    return {
      startsAt: this.initialLimit || 0,
      displayName: BlockLabel.FixedAmount,
      intervals: Array<Interval>(),
      infiniteUpperLimit: false,
      feeBase: FeeBase.SalaryBase,
      feeBaseDescription: "",
      trappe: false,
    };
  },
  computed: {
    FeeBase() {
      return FeeBase;
    },
  },
  mounted() {
    if (this.data) {
      this.startsAt = this.data.startsAt;
      this.intervals = this.data.intervals;
      this.infiniteUpperLimit = this.data.infiniteUpperLimit;
      this.feeBase = Object.values(FeeBase)[this.data.feeBase];
      this.feeBaseDescription = this.data.feeBaseDescription;
      this.trappe = this.data.trappe;
    } else {
      this.addInterval();
    }
  },
  methods: {
    addInterval() {
      var newInterval = createNewDefaultInterval(this.intervals, {
        startsAt: this.startsAt,
        defaultAmount: 1000,
      });
      this.intervals.push(newInterval);
    },
    removeInterval() {
      this.intervals.pop();
    },
    expandBlock() {
      this.$emit("setBlockExpanded", this.blockId);
    },
    collapseBlock() {
      this.$emit("updateBlock", {
        blockId: this.blockId,
        type: this.$options.name,
        intervals: this.intervals,
        startsAt: this.startsAt,
        feeBase: this.getFeeBaseIndex(this.feeBase),
        feeBaseDescription: this.getFeeBaseDescription(),
        infiniteUpperLimit: this.infiniteUpperLimit,
        trappe: this.trappe,
      });
      this.$emit(
        "highestIntervalValue",
        this.intervals[this.intervals.length - 1].upperLimit
      );
    },
    getFeeBaseIndex(value: string): number {
      const index = Object.values(FeeBase).indexOf(value);
      return index;
    },
    getFeeBaseLabel(): string {
      const index = this.getFeeBaseIndex(this.feeBase);
      return index == 2
        ? this.feeBaseDescription
        : Object.values(FeeBase)[index];
    },
    getFeeBaseDescription(): string | undefined {
      let index = this.getFeeBaseIndex(this.feeBase);
      return index == 2 ? this.feeBaseDescription : undefined;
    },
    getLowerLimit(index: number): number {
      if (index == 0) return this.startsAt;

      return this.intervals[index - 1].upperLimit;
    },
    getNewColor(index: number): string {
      var colors = ["#39CCCC", "#FF9186", "#B4DA55", "#B5649b"];

      index = index % colors.length;

      return colors[index];
    },
    shortenedNumber(number: number): string {
      return NumberFormatter.shortForm(number, 3);
    },
    asCurrency(number: number) {
      return `kr ${NumberFormatter.withThousandsSeparator(number, " ")}`;
    },
    isLast(list: Array<any>, index: number) {
      return index + 1 == list.length;
    },
  },
});
